import React, { Component } from 'react';
import { toast } from 'react-toastify';

import Spinner from 'components/Spinner';
import UpdateDeviceModalForm from './UpdateDeviceModalForm';
import BaseModal from '../BaseModal';

import styles from './styles.module.scss';

class UpdateDeviceModal extends Component {
  state = {
    loading: false,
    preactivationRequested: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      !prevProps.isOpen &&
      this.props.isOpen &&
      this.props.findPreactivation &&
      !this.props.preactivation &&
      this.props.preactivationId &&
      !this.state.preactivationRequested
    ) {
      this.loadPreactivation();
    }
  }

  transformValues = (values) => {
    const { isSimo } = this.props;

    if (isSimo) {
      let newValues = { ...values };

      newValues.device_status = undefined;

      return newValues;
    }

    return values;
  };

  loadPreactivation = async () => {
    const { preactivationId, findPreactivation } = this.props;
    if (preactivationId && findPreactivation) {
      try {
        this.setState({ loading: true, preactivationRequested: true });
        await findPreactivation(preactivationId);
      } catch (e) {
      } finally {
        this.setState({ loading: false });
      }
    }
  };

  handleUpdateDevice = (values) => {
    const { sub, updateDevice, findSub, closeModal } = this.props;

    this.setState({ loading: true });
    return updateDevice(sub.id, this.transformValues(values))
      .then(() => findSub(sub.id))
      .then(() => {
        closeModal();
        toast.success('Device details updated');
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const {
      sub,
      preactivation,
      isOpen,
      closeModal,
      isSimo,
      isAtt,
      isQuick,
      isAdmin,
    } = this.props;
    const { loading } = this.state;
    const initialValues = mapModelsToValues(sub, preactivation);

    return (
      <BaseModal
        isOpen={isOpen}
        title="Update Device"
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        <UpdateDeviceModalForm
          sub={sub}
          initialValues={initialValues}
          onSubmit={this.handleUpdateDevice}
          isSimo={isSimo}
          isAtt={isAtt}
          isQuick={isQuick}
          isAdmin={isAdmin}
        />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

const mapModelsToValues = (sub, preactivation = {}) => {
  if (preactivation === null) {
    preactivation = {};
  }

  if (sub.simo_status) {
    return {
      device_sn: sub.device_sn || undefined,
      sync: false,
    };
  }

  return {
    device_id: sub?.device_id || preactivation?.device_id,
    device_status: sub?.device_status,
    icc_id: sub?.icc_id || preactivation?.icc_id,
    platform: sub?.platform,
  };
};

export default UpdateDeviceModal;
